/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { ConnectedProps, connect, useDispatch, useSelector } from 'react-redux';
import { putItems } from '../../redux/components/reducer.action';
import { initializeReactGA } from '../../middleware/googleAnalytics';
import {
  viewContent,
  fetchContent,
  fetchCollabView,
  fetchTemplateView,
} from '../../middleware/api';
import PostHeightIframe from './dynamicIframeHeight';
import {
  appendCustomFontUrlToHeader,
  attachCustomFontUrl,
  getEditStatus,
} from '../../middleware/utils';
import { FlipcardComponent } from './flipCard/view';
import { getLibraryId, insertBrInEmptyBlocks } from '../formComponent/utils';
import TabComponent from './tabs';
import AccordionComponent from './accordion/accordion';
import ButtonComponent from './button';
import ClickAndRevealComponent from './clickAndReveal';
import HotspotViewComponent from './hotspot/hotspotView';
import ImageSlider from './imageSlider';
import DragAndDropComponent from './draganddrop';
import MCQComponent from './multipleChoice';
import HandleErrorComponent from '../../errorHandler';
import { handleEmbedLINT } from '../interactiveManagement/utils';
import '../../components/editor/editor.scss';
import { SelectedElementDetails } from '../interactiveManagement';
import { ReactComponent as BackIcon } from '../../assets/icons/backIcon.svg';
import InteractiveLoader from '../loader/interactiveLoader';
import { ParentDataInterface, setInteractiveState } from '../../redux/parentDataSlice';
import ChecklistComponent from './checklist';
import { setInteractiveType } from '../../redux/handleBrowserBack';
import LoaderComponent from '../utils/loader';

const getInteractiveViewComponent = (
  parameters: any,
  customisations: any,
  type: string,
  id: string,
  isLmsView: boolean,
) => {
  switch (type) {
    case 'Accordion':
      return (
        <AccordionComponent
          parameters={parameters}
          customisations={customisations}
          isLMSView={isLmsView}
        />
      );
    case 'Tabs':
      return <TabComponent parameters={parameters} customisations={customisations} />;
    case 'Button':
    case 'button':
      return <ButtonComponent parameters={parameters} customisations={customisations} />;
    case 'ClickAndRevealInteractions':
      return <ClickAndRevealComponent parameters={parameters} customisations={customisations} />;
    case 'imageslider':
      return <ImageSlider parameters={parameters} customisations={customisations} />;
    case 'Hotspot':
      return <HotspotViewComponent parameters={parameters} customisations={customisations} />;
    case 'DragandDrop':
      return <DragAndDropComponent parameters={parameters} customisations={customisations} />;
    case 'multiplechoice':
      return <MCQComponent parameters={parameters} customisations={customisations} />;
    case 'flipcard':
      return (
        <FlipcardComponent
          parameters={parameters}
          customisations={customisations}
          id={id}
          type='view'
        />
      );
    case 'checklist':
      return <ChecklistComponent parameters={parameters} customisations={customisations} />;
  }
};

const mapState = ({ component }: any) => ({
  title: component.title,
  parameters: component.parameters,
  customisations: component.customisations,
});

const mapDispatch = (dispatch: Function) => ({
  PutItems: (component: {}) => dispatch(putItems(component)),
});

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & any;

const InteractiveView = (props: Props) => {
  const { title, parameters, customisations } = props;
  const { id } = props.match.params;
  const path = props.location.pathname.toLowerCase();
  const isLMSView =
    !path.toLowerCase().includes('/new') && !path.toLowerCase().includes('/contentview');
  const applyMargin = !isLMSView ? 'margin container-fluid pt-3' : '';
  const [editStatus, setEditStatus] = useState(false);
  const [componentType, setComponentType] = useState('');
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [activeLINT, setActiveLINT] = useState(true);
  const [isGlobal, setIsGlobal] = useState(false);
  const [isShared, setIsShared] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const dataFromParent = useSelector((state: ParentDataInterface) => state.parentData.data);
  const customConfiguration = useSelector(
    (state: ParentDataInterface) => state.parentData.customConfiguration,
  );
  const interactiveState = useSelector(
    (state: ParentDataInterface) => state.parentData.interactiveState,
  );
  const [isCollaborative] = useState(interactiveState === 'collaborative');
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isLMSView) return;
    history.push(location.pathname);

    const handlePop = () => {
      handleBackPage();
    };

    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, [isGlobal, isShared, isPrivate]);

  useEffect(() => {
    if (!dataFromParent && !isLMSView) {
      return props.history.push('/401');
    }
    let isSameWindow = true;
    try {
      isSameWindow = window.self !== window.top;
    } catch (e) {
      isSameWindow = true;
    }

    if (!isSameWindow) {
      return props.history.push('/401');
    }
    const { id, type } = props.match.params;
    const { PutItems } = props;
    if (!isLMSView) {
      initializeReactGA(path, dataFromParent);
    } else {
      PostHeightIframe();
      attachCustomFontUrl();
    }
    const fetchData = async () => {
      try {
        let response;
        const isCollaborativePath = path.toLowerCase().includes('collaborative');
        const isTemplatePath = path.toLowerCase().includes('templatedlint');
        if (!isCollaborative && !isCollaborativePath && !isTemplatePath) {
          response = isLMSView
            ? await viewContent(id, type)
            : await fetchContent(id, dataFromParent.userId);
        } else {
          response =
            isTemplatePath || dataFromParent?.collabType === 'template'
              ? await fetchTemplateView(id)
              : await fetchCollabView(id);
        }
        const isInvalidLMSResponse =
          isLMSView &&
          (response?.info ||
            type.toLowerCase() !== response?.type?.toLowerCase() ||
            response?.active === false);
        if (isInvalidLMSResponse || !response) {
          props.history.push('/204');
          return;
        }

        setIsGlobal(response?.global);
        setIsShared(!response?.global && !response?.private);
        setIsPrivate(response?.private);
        setActiveLINT(response.active);
        const isValidResponse =
          !response.message && response.library_id === getLibraryId(response.type);
        if (isValidResponse) {
          if (customConfiguration) {
            const editStatus = getEditStatus(
              response.private,
              response.global,
              isCollaborative,
              customConfiguration.config,
            );
            setEditStatus(editStatus);
          }
          setComponentType(response.type);
          PutItems({
            title: response.title,
            parameters:
              response.type === 'Button' || response.type === 'checklist'
                ? response.parameters
                : insertBrInEmptyBlocks(JSON.parse(response.parameters), response.type),
            customisations: response.customisations,
          });
          setLoading(false);
        } else {
          props.history.push('/401');
        }

        let configData;
        let fontFamilyConfigList = [];
        if (!isLMSView) {
          fontFamilyConfigList = customConfiguration?.fontFamilyList?.fonts ?? [];
        } else {
          configData = JSON.parse(response.customisations.fontsList ?? null);
          fontFamilyConfigList = configData ?? [];
        }

        appendCustomFontUrlToHeader(fontFamilyConfigList ?? []);
      } catch (error) {
        console.error('Error while fetching interactive content', error);
        setLoading(false);
        setIsError(true);
      }
    };
    fetchData();
  }, [isLMSView]);

  const handleEmbed = () => {
    const CurrentElementDetails: SelectedElementDetails = {
      id: props.match.params.id,
      title: title,
      library_type: props.match.params.type,
      isCollaborative,
    };
    handleEmbedLINT(CurrentElementDetails);
  };

  const handleBackPage = () => {
    let redirectPath = '';
    switch (true) {
      case isGlobal:
        redirectPath = '/global';
        break;
      case isShared:
        redirectPath = '/shared';
        break;
      case isPrivate:
        redirectPath = '/interactives';
        break;
    }
    props.history.push(redirectPath);
    dispatch(setInteractiveState(redirectPath));
  };

  const isOPenInteractive = interactiveState === 'collaborative';

  return (
    <div className={`${isOPenInteractive ? 'libraryDashboardMain' : ''}`}>
      {isOPenInteractive && (
        <div className='createOpenInteractiveTitle'>
          <div className='title'>Open Interactive</div>
        </div>
      )}
      {isLMSView && loading && <LoaderComponent />}
      {!isLMSView && loading && <InteractiveLoader loaderType='' />}
      <div className={applyMargin} id='componentView' style={isLMSView ? {} : { height: '92.5vh' }}>
        {!loading && !isLMSView && !isError && (
          <Row className='d-flex justify-content-between mb-3'>
            <Col
              className='col-10 d-flex align-items-center'
              style={{ wordBreak: 'break-word', gap: 8 }}
            >
              {interactiveState !== 'collaborative' && (
                <span
                  className='d-flex backButton align-items-center'
                  style={{ color: '#585858', cursor: 'pointer', gap: '5px' }}
                  onClick={handleBackPage}
                  tabIndex={0}
                  role='button'
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleBackPage();
                    }
                  }}
                >
                  <BackIcon />
                  Back
                </span>
              )}
              <h2
                className='m-0 d-flex align-items-center'
                style={{ color: '#112299', fontSize: '18px', fontWeight: 400 }}
              >
                {title}
              </h2>
            </Col>
            <Col className='col-2'>
              <div className='d-flex justify-content-end ' style={{ gap: '20px' }}>
                {editStatus && (
                  <Link
                    style={{ color: 'black' }}
                    className='float-end pt-1'
                    to={{
                      pathname: `/component/edit/${componentType}/${id}`,
                    }}
                    onClick={() => {
                      dispatch(setInteractiveType(path));
                    }}
                  >
                    Edit
                  </Link>
                )}
                <button
                  className='btn btn-primary btn-sm embed-btn'
                  disabled={!activeLINT}
                  onClick={() => handleEmbed()}
                >
                  Embed
                </button>
              </div>
            </Col>
          </Row>
        )}
        {!loading && !isError && (
          <>
            {getInteractiveViewComponent(parameters, customisations, componentType, id, isLMSView)}
          </>
        )}
        {!loading && isError && <HandleErrorComponent />}
      </div>
    </div>
  );
};

export default connector(InteractiveView);
